export enum FileReviewExpandWorks {
    ready,
    error,
}
